const MORE_SELECTOR = ".js-more";
const MORE_MENU_SELECTOR = ".js-more__menu";
const MORE_BTN_SELECTOR = ".js-more__btn";
const MORE_LIST_SELECTOR = ".js-more__list";
const BREAKPOINT_NAME = "--brkp-burger";

const HEADER_SELECTOR = ".header";
const CONTAINER_SELECTOR = ".container";

export const initMore = () => {
    const moreWrap = document.querySelector(MORE_SELECTOR);
    if (!moreWrap) return;

    const moreBtn = moreWrap.querySelector(MORE_BTN_SELECTOR);
    const moreList = moreWrap.querySelector(MORE_LIST_SELECTOR);
    const moreMenu = moreWrap.querySelector(MORE_MENU_SELECTOR);
    const header = document.querySelector(HEADER_SELECTOR);
    const headerCont = header?.querySelector(CONTAINER_SELECTOR);

    // Get the breakpoint value from CSS variable
    const breakpointValue = parseInt(
        getComputedStyle(document.documentElement)
            .getPropertyValue(BREAKPOINT_NAME)
            .replace(/px/, "")
    );

    let currentWidth = window.innerWidth;
    let isMob = window.innerWidth <= breakpointValue;
    let isDeviceChanged = true;

    // Move the last visible menu item to the hidden list
    function hideLastElement() {
        if (moreBtn) moreBtn.style.display = "block";
        const lastElement = moreBtn?.previousElementSibling;
        if (lastElement) {
            lastElement.dataset.width = lastElement.offsetWidth;
            moreList?.prepend(lastElement);
        }
    }

    // Move the first hidden list item back to the visible menu
    function showLastElement() {
        if (!moreList) return;

        const firstItem = moreList.firstElementChild;
        if (!firstItem) return;

        const width = parseInt(firstItem.dataset.width || firstItem.offsetWidth, 10);

        if (!isNaN(width) && width < calcAvailableWidth()) {
            moreMenu?.insertBefore(firstItem, moreBtn);
        } else if (moreList.childElementCount === 0 && moreBtn) {
            moreBtn.style.display = "none";
        }
    }


    // Calculate available width in the more menu
    function calcAvailableWidth() {
        return moreWrap?.offsetWidth - moreMenu.offsetWidth;
    }


    // Reset DOM structure by moving all items to the visible menu
    function resetDom() {
        const menuItems = moreList?.querySelectorAll(".js-more__item");
        menuItems?.forEach((el) => {
            moreMenu?.insertBefore(el, moreBtn);
        });
        if (moreBtn) moreBtn.style.display = "none";
    }

    // Handle window resize event
    window.addEventListener("resize", () => {
        if (currentWidth === window.innerWidth) return;
        currentWidth = window.innerWidth;
        isDeviceChanged = isMob !== window.innerWidth <= breakpointValue;
        isMob = window.innerWidth <= breakpointValue;
        checkBreakpoint();
    });

    // Update the more menu based on available width
    function updateMoreMenu() {
        if (calcAvailableWidth() <= 0) {
            if (isDeviceChanged && !isMob) {
                while (calcAvailableWidth() <= 0) {
                    hideLastElement();
                }
            } else {
                hideLastElement();
            }
        } else {
            showLastElement();
        }
    }

    // Check breakpoint and update menu accordingly
    const checkBreakpoint = () => {
        if (window.innerWidth <= breakpointValue) {
            resetDom();
        } else {
            updateMoreMenu();
        }
    };

    // Initial check to set up the menu
    window.addEventListener('load', checkBreakpoint);
};